import React from 'react';
import { Link } from 'react-router-dom';
import '../styles/HomePage.css';

const HomePage = () => {
  return (
    <>
      <div className="bg-animation"></div>
      <div className="floating-shapes">
        <div className="shape"></div>
        <div className="shape"></div>
        <div className="shape"></div>
        <div className="shape"></div>
        <div className="shape"></div>
        <div className="shape"></div>
      </div>

      <section className="hero-section" id="home">
        <div className="container">
          <div className="hero-content">
            <div className="hero-badge">خدمة توصيل متميزة</div>
            <h1 className="hero-title">
              <span className="hero-title-line">ZED</span>
              <span className="hero-title-line">نصلك أينما كنت</span>
            </h1>
            <div className="service-24-7">
              <div className="pulse-badge">
                <span className="live-dot"></span>
                نعمل 24 ساعة
              </div>
            </div>
            <div className="hero-features">
              <div className="feature-item">
                <div className="feature-icon">⚡</div>
                <span>توصيل سريع</span>
              </div>
              <div className="feature-item">
                <div className="feature-icon">📍</div>
                <span>حدد موقعك وسيب الباقي علينا</span>
              </div>
              <div className="feature-item">
                <div className="feature-icon">🌙</div>
                <span>خدمة متواصلة 24/7</span>
              </div>
            </div>
            <div className="hero-cta">
              <Link to="/order" className="btn btn-primary">
                <span className="btn-text">اطلب الآن</span>
                <span className="btn-icon">→</span>
              </Link>
              <a 
                href="#about" 
                className="btn btn-secondary"
                onClick={(e) => {
                  e.preventDefault();
                  document.getElementById('about').scrollIntoView({ 
                    behavior: 'smooth',
                    block: 'start'
                  });
                }}
              >
                تعرف علينا
              </a>
            </div>
          </div>
          <div className="hero-image">
            <div className="image-container neon-effect">
              <img src={require('../assets/images/zedorder-delievery-v1.png')} alt="Delivery Service" className="hero-img" />
            </div>
          </div>
        </div>
      </section>

      {/* Stats Section */}
      <section className="stats-section">
        <div className="container">
          <div className="stats-grid">
            <div className="stat-item">
              <span className="stat-number" data-target="15000">60,000+</span>
              <span className="stat-label">Deliveries Completed</span>
            </div>
            <div className="stat-item">
              <span className="stat-number" data-target="98">98%</span>
              <span className="stat-label">Customer Satisfaction</span>
            </div>
            <div className="stat-item">
              <span className="stat-number" data-target="45">25min</span>
              <span className="stat-label">Average Delivery Time</span>
            </div>
            <div className="stat-item">
              <span className="stat-number" data-target="200">99+</span>
              <span className="stat-label">Professional Riders</span>
            </div>
          </div>
        </div>
      </section>

      {/* آراء العملاء */}
      <section className="testimonials-section">
        <div className="container">
          <h2 className="section-title">آراء عملائنا</h2>
          <div className="testimonials-slider-container">
            <div className="testimonials-slider">
              <div className="testimonials-track">
                {/* Original Set */}
                <div className="testimonial-card">
                  <div className="testimonial-content">
                    <div className="rating">⭐⭐⭐⭐⭐</div>
                    <p className="testimonial-text">"والله يا جماعة خدمة جامدة جداً، الديليفري جه في الميعاد بالظبط وكان محترم جداً. أنا بقالي كذا مرة بطلب وكل مرة نفس المستوى العالي"</p>
                    <div className="testimonial-author">أحمد محمود - حي السلام</div>
                  </div>
                </div>
                <div className="testimonial-card">
                  <div className="testimonial-content">
                    <div className="rating">⭐⭐⭐⭐⭐</div>
                    <p className="testimonial-text">"مفيش أحسن من كده! طلبت في نص الليل وفي البرد والمطر، والراجل جه في أسرع وقت. تسلم إيدكم يا زد"</p>
                    <div className="testimonial-author">سارة علي - الشيخ زايد</div>
                  </div>
                </div>
                <div className="testimonial-card">
                  <div className="testimonial-content">
                    <div className="rating">⭐⭐⭐⭐⭐</div>
                    <p className="testimonial-text">"بجد خدمة تجنن، أنا كنت محتاج حاجة ضروري من الصيدلية وكان الدنيا ليل، اتصلت بيهم وفي 20 دقيقة بس كانت الطلبية عندي"</p>
                    <div className="testimonial-author">محمد خالد - الجمعيات</div>
                  </div>
                </div>
                <div className="testimonial-card">
                  <div className="testimonial-content">
                    <div className="rating">⭐⭐⭐⭐⭐</div>
                    <p className="testimonial-text">"يا جماعة دي أحسن خدمة توصيل في الإسماعيلية، الطلب بيوصل في الوقت المحدد وبيتعاملوا باحترام جداً"</p>
                    <div className="testimonial-author">منى أحمد - عرايشية مصر</div>
                  </div>
                </div>
                {/* Duplicate Set for Seamless Loop */}
                <div className="testimonial-card">
                  <div className="testimonial-content">
                    <div className="rating">⭐⭐⭐⭐⭐</div>
                    <p className="testimonial-text">"الموقف سهل الاستخدام والسواق محترم. كان في تأخير بسيط 10 دقايق بس عادي بالنسبة للزحمة. تجربة كويسة وهكررها</p>
                    <div className="testimonial-author">مني السيد - الغابه</div>
                  </div>
                </div>
                <div className="testimonial-card">
                  <div className="testimonial-content">
                    <div className="rating">⭐⭐⭐⭐⭐</div>
                    <p className="testimonial-text">"مفيش أحسن من كده! طلبت في نص الليل وفي البرد والمطر، والراجل جه في أسرع وقت. تسلم إيدكم يا زد"</p>
                    <div className="testimonial-author">سارة علي - الشيخ زايد</div>
                  </div>
                </div>
                <div className="testimonial-card">
                  <div className="testimonial-content">
                    <div className="rating">⭐⭐⭐⭐⭐</div>
                    <p className="testimonial-text">"بجد خدمة تجنن، أنا كنت محتاج حاجة ضروري من الصيدلية وكان الدنيا ليل، اتصلت بيهم وفي 20 دقيقة بس كانت الطلبية عندي"</p>
                    <div className="testimonial-author">محمد خالد - المنشية</div>
                  </div>
                </div>
                <div className="testimonial-card">
                  <div className="testimonial-content">
                    <div className="rating">⭐⭐⭐⭐⭐</div>
                    <p className="testimonial-text">"يا جماعة دي أحسن خدمة توصيل في الإسماعيلية، الطلب بيوصل في الوقت المحدد وبيتعاملوا باحترام جداً"</p>
                    <div className="testimonial-author">منى أحمد - عرايشية مصر</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default HomePage;
